import qs from 'qs';

import useToastedMutation from '../../../ReactQuery/useToastedMutation';
import { post } from '../../../redux/api';
import type { ReanalyzeQuickImportRequest } from '../../../../typings/api';

type RebuildPackageCacheParams = {
  organizationId: number;
  reduceConcurrency: boolean;
};

async function rebuildPackageCache({ organizationId, reduceConcurrency }: RebuildPackageCacheParams): Promise<void> {
  await post<ReanalyzeQuickImportRequest, Record<string, never>>(
    `/api/packages/rebuild-cache?${qs.stringify({
      organizationId,
      reduceConcurrency,
    })}`,
    {},
  );
}

/**
 * Hook to rebuild the organization package cache.
 * @returns Mutation function to trigger package cache rebuild
 */
export const useRebuildPackageCache = () => {
  return useToastedMutation({
    mutationFn: rebuildPackageCache,
    successToastMessage: 'Package cache rebuild queued successfully',
    errorToastMessage: 'Failed to queue package cache rebuild',
  });
};
